import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { toast } from "react-toastify";
import { Col, FormGroup, Input, Label, Row } from 'reactstrap';
import {
   ScheduleShipmentAnalysisGrid, ServiceThreadSpinner, ShippingScheduleConsignedGrid,
   ShipScheduleCurrentWeekGrid, ShipScheduleSampleOrderGrid
} from '.';
import { api, constants, dateHelpers, helpers } from '../utils';

// Date requirements for radio buttons
let weekEndDate;
let weekStartDate;
let today = new Date();
let tomorrow = new Date();
let tomorrowDate = dateHelpers.toLongDateString(tomorrow.setDate(today.getDate() + 1));
let weekday = today.getDay();
let monthDay = today.getDate();

let date = new Date();
let dateEnd = new Date();
switch (weekday) {
   case 0:
      weekStartDate = dateHelpers.toLongDateString(date.setDate(monthDay + 1));
      weekEndDate = dateHelpers.toLongDateString(dateEnd.setDate(monthDay + 5));
      break;
   case 1:
      weekStartDate = dateHelpers.toLongDateString(date);
      weekEndDate = dateHelpers.toLongDateString(dateEnd.setDate(monthDay + 4));
      break;
   case 2:
      weekStartDate = dateHelpers.toLongDateString(date.setDate(monthDay - 1));
      weekEndDate = dateHelpers.toLongDateString(dateEnd.setDate(monthDay + 3));
      break;
   case 3:
      weekStartDate = dateHelpers.toLongDateString(date.setDate(monthDay - 2));
      weekEndDate = dateHelpers.toLongDateString(dateEnd.setDate(monthDay + 2));
      break;
   case 4:
      weekStartDate = dateHelpers.toLongDateString(date.setDate(monthDay - 3));
      weekEndDate = dateHelpers.toLongDateString(dateEnd.setDate(monthDay + 1));
      break;
   case 5:
      weekStartDate = dateHelpers.toLongDateString(date.setDate(monthDay - 4));
      weekEndDate = dateHelpers.toLongDateString(dateEnd);
      break;
   case 6:
      weekStartDate = dateHelpers.toLongDateString(date.setDate(monthDay + 2));
      weekEndDate = dateHelpers.toLongDateString(dateEnd.setDate(monthDay + 6));
      break;
   default:
      break;
}

export default function SalesDashboardShipSchedule(props) {
   const [data, setData] = useState();
   const [dropShippingScheduleSortDirection, setDropShippingScheduleSortDirection] = useState("asc");
   const [dropShippingScheduleSortField, setDropShippingScheduleSortField] = useState("CustomerId");
   const [loaded, setLoaded] = useState(false);
   const [machinePartScheduleSortDirection, setMachinePartScheduleSortDirection] = useState("asc");
   const [machinePartScheduleSortField, setMachinePartScheduleSortField] = useState("CustomerId");
   const [periodType, setPeriodType] = useState("today");
   const [salespersonId, setSalespersonId] = useState(props.salespersonId);
   const [sampleOrderSortDirection, setSampleScheduleSortDirection] = useState("asc");
   const [sampleOrderSortField, setSampleScheduleSortField] = useState("CustomerId");
   const [shipScheduleSortDirection, setShipScheduleSortDirection] = useState("asc");
   const [shipScheduleSortField, setShipScheduleSortField] = useState("CustomerId");
   const currentDate = dateHelpers.toLongDateString(new Date());

   useEffect(() => {
      if (props.salespersonId !== salespersonId) {
         setSalespersonId(props.salespersonId);
         // back to default sorts
         setShipScheduleSortField("CustomerId");
         setShipScheduleSortDirection("asc");
         setMachinePartScheduleSortField("CustomerId");
         setMachinePartScheduleSortDirection("asc");
         setSampleScheduleSortField("CustomerId");
         setSampleScheduleSortDirection("asc");
         setDropShippingScheduleSortField("CustomerId");
         setDropShippingScheduleSortDirection("asc");
         setLoaded(false);
      }
      if (!loaded) {
         loadData();
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [loaded, props.salespersonId])

   function createPayload() {
      const payload = {};
      if (periodType === "today") {
         payload.endDate = dateHelpers.utcDayEnd(currentDate);
         payload.PeriodType = "todayRadio";
      }
      else if (periodType === "tomorrow") {
         payload.startDate = dateHelpers.utcDayStart(tomorrowDate);
         payload.endDate = dateHelpers.utcDayEnd(tomorrowDate);
         payload.PeriodType = "tomorrowRadio";
      }
      else {  // current_week
         payload.startDate = dateHelpers.utcDayStart(weekStartDate);
         payload.endDate = dateHelpers.utcDayEnd(weekEndDate);
         payload.PeriodType = "thisWeekRadio";
      }

      payload.InShippingSchedule = true; // since we are now using date ranges
      payload.IsWarehouse = false; // Should only ever be true in the warehouse shipping schedule, NOT HERE
      payload.salesPersonId = props.salespersonId;
      payload.ShipScheduleSortField = shipScheduleSortField;
      payload.ShipScheduleSortDirection = shipScheduleSortDirection;
      payload.MachinePartScheduleSortField = machinePartScheduleSortField;
      payload.MachinePartScheduleSortDirection = machinePartScheduleSortDirection;
      payload.DropShippingScheduleSortField = dropShippingScheduleSortField;
      payload.DropShippingScheduleSortDirection = dropShippingScheduleSortDirection;
      return payload;
   }

   function dropShippingScheduleSortChange(field, direction) {
      if (field !== dropShippingScheduleSortField) {
         setDropShippingScheduleSortField(field);
         setDropShippingScheduleSortDirection("asc")
      } else {
         setDropShippingScheduleSortDirection(direction);
      }
      setLoaded(false);
   }

   function exportConsignedOrdersXlsx() {
      api.postGetBlob("Sales/ExportShipScheduleConsignedOrderXLSX", {
         SalesPersonId: props.salespersonId
      })
         .then(r => {
            if (r.data.success === false) {
               if (_.isString(r?.data?.message)) {
                  toast.error(r?.data?.message);
               }
               return;
            }
            if (r.data) {
               const XLSX_FILENAME = props.salespersonId
                  ? `${props.salespersonId}_ConsignedShipSchedule.xlsx`
                  : "ConsignedShipSchedule.xlsx"; // `${props.salespersonId}_ShipScheduleConsignedOrders.xlsx`
               helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx)
            } else {
               toast.error(r.message || "Error downloading report");
            }
         })
         .catch(api.catchHandler);

   }

   function exportSampleOrderXlsx() {
      api
         .postGetBlob("Sales/ExportShipScheduleSampleOrderXLSX", {
            SalesPersonId: props.salespersonId
         })
         .then(r => {
            if (r.data.success === false) {
               if (_.isString(r?.data?.message)) {
                  toast.error(r?.data?.message);
               }
               return;
            }
            if (r.data) {
               const XLSX_FILENAME = props.salespersonId
                  ? `${props.salespersonId}_SamplesShipSchedule.xlsx`
                  : "SamplesShipSchedule.xlsx"; // `${props.salespersonId}_ShipScheduleSampleOrders.xlsx`
               helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx)
            } else {
               toast.error(r.message || "Error downloading report");
            }
         })
         .catch(api.catchHandler);
   }

   function exportXlsx(schedule) {
      let pay = createPayload();
      pay.Schedule = schedule;
      api
         .postGetBlob("Sales/ExportShipScheduleCurrentWeekXLSX", pay)
         .then(r => {
            if (r.data.success === false) {
               if (_.isString(r?.data?.message)) {
                  toast.error(r?.data?.message);
               }
               return;
            }
            if (r.data) {
               let XLSX_FILENAME = props.salespersonId ? `${props.salespersonId}_` : "";
               if (schedule === constants.SHIPPING_SCHEDULE_TYPES.DropShipping)
                  XLSX_FILENAME = `${XLSX_FILENAME}DropShipSchedule.xlsx`
               else
                  XLSX_FILENAME = `${XLSX_FILENAME}${schedule === constants.SHIPPING_SCHEDULE_TYPES.MachinePartShipping
                     ? 'MachinePartSchedule'
                     : 'ShipSchedule'}.xlsx`
               helpers.downloadExport(r.data, XLSX_FILENAME, constants.MIME_TYPES.xlsx)
            } else {
               toast.error(r.message || "Error downloading report");
            }
         })
         .catch(api.catchHandler);
   }

   function loadData() {
      let pay = createPayload();
      api
         .post("Sales/LoadSalesDashboardShipSchedule", pay)
         .then(response => {
            if (response.data.success) {
               setData(response.data.shipScheduleData)
            }
            setLoaded(true)
         })
         .catch(api.catchHandler);
   }

   function onDisplayOptionChange(option) {
      setPeriodType(option);
      setLoaded(false);
   }

   function onMachinePartScheduleSortChange(field, direction) {
      if (field !== machinePartScheduleSortField) {
         setMachinePartScheduleSortField(field);
         setMachinePartScheduleSortDirection("asc")
      } else {
         setMachinePartScheduleSortDirection(direction);
      }
      setLoaded(false);
   }

   function onSampleOrderScheduleSortChange(field, direction) {
      if (field !== machinePartScheduleSortField) {
         setSampleScheduleSortField(field);
         setSampleScheduleSortDirection("asc")
      } else {
         setSampleScheduleSortDirection(direction);
      }
      setLoaded(false);
   }

   function onShipScheduleSortChange(field, direction) {
      if (field !== shipScheduleSortField) {
         setShipScheduleSortField(field);
         setShipScheduleSortDirection("asc")
      } else {
         setShipScheduleSortDirection(direction);
      }
      setLoaded(false);
   }

   return (
      <React.Fragment>
         <ServiceThreadSpinner on={!loaded}>
            <div className="mb-3">
               <span className="h2 me-2">Ship Schedule</span>
            </div>
            {/* <hr /> */}
            <div className="mb-0">
               <span className="h5 me-2 text-muted">Schedule Shipment Analysis</span>
               <hr className="mt-0" />
            </div>
            <Row className="mb-3">
               <Col>
                  {data && data.shipScheduleSummaryData
                     ? <ScheduleShipmentAnalysisGrid
                        summaryData={data.shipScheduleSummaryData}
                     />
                     : null
                  }
               </Col>
            </Row>
            {data ?
               <div style={{ border: "1px solid #bbb", borderRadius: "10px", padding: "3px", width: "40%" }}>
                  <FormGroup check inline>
                     <Label check>
                        <Input
                           type="radio"
                           name="radio1"
                           checked={periodType === 'current_week'}
                           onChange={e => onDisplayOptionChange('current_week')}
                        /> Current Week
                     </Label>
                  </FormGroup>
                  <FormGroup check inline>
                     <Label check>
                        <Input
                           type="radio"
                           name="radio1"
                           checked={periodType === 'today'}
                           onChange={e => onDisplayOptionChange('today')}
                        /> Today
                     </Label>
                  </FormGroup>
                  <FormGroup check inline>
                     <Label check>
                        <Input
                           type="radio"
                           name="radio1"
                           checked={periodType === 'tomorrow'}
                           onChange={e => onDisplayOptionChange('tomorrow')}
                        /> Tomorrow
                     </Label>
                  </FormGroup>
               </div>
               : null
            }
            <br />
            <div>
               <span className="h5 me-2 text-muted">Ship Schedule Current Week</span>
               <hr className="mt-0" />
            </div>
            <Row className="mb-3">
               <Col>
                  {data && data.shipScheduleData && data.shipScheduleData.length ?
                     <ShipScheduleCurrentWeekGrid
                        data={data.shipScheduleData}
                        sortCallback={onShipScheduleSortChange}
                        sortField={shipScheduleSortField}
                        sortDirection={shipScheduleSortDirection}
                        onUpdateRow={() => setLoaded(false)}
                        exportXlsxCallback={exportXlsx}
                        schedule={constants.SHIPPING_SCHEDULE_TYPES.AllShipping}
                     />
                     : <span className="h5" style={{ color: "red" }}>No standard orders found</span>
                  }
               </Col>
            </Row>
            <div>
               <span className="h5 me-2 text-muted">Machine Part Schedule Current Week</span>
               <hr className="mt-0" />
            </div>
            <Row className="mb-3">
               <Col>
                  {data && data.machinePartScheduleData && data.machinePartScheduleData.length > 0
                     ? <ShipScheduleCurrentWeekGrid
                        data={data.machinePartScheduleData}
                        sortCallback={onMachinePartScheduleSortChange}
                        sortField={machinePartScheduleSortField}
                        sortDirection={machinePartScheduleSortDirection}
                        onUpdateRow={() => setLoaded(false)}
                        exportXlsxCallback={exportXlsx}
                        schedule={constants.SHIPPING_SCHEDULE_TYPES.MachinePartShipping}
                     />
                     : <span className="h5" style={{ color: "red" }}>No machine part orders found</span>
                  }
               </Col>
            </Row>
            <div>
               <span className="h5 me-2 text-muted">Drop Ship Schedule Current Week</span>
               <hr className="mt-0" />
            </div>
            <Row className="mb-3">
               <Col>
                  {data && data.dropShippingData && data.dropShippingData.length > 0
                     ? <ShipScheduleCurrentWeekGrid
                        data={data.dropShippingData}
                        sortCallback={dropShippingScheduleSortChange}
                        sortField={dropShippingScheduleSortField}
                        sortDirection={dropShippingScheduleSortDirection}
                        onUpdateRow={() => setLoaded(false)}
                        exportXlsxCallback={exportXlsx}
                        schedule={constants.SHIPPING_SCHEDULE_TYPES.DropShipping}
                     />
                     : <span className="h5" style={{ color: "red" }}>No drop ship orders found</span>
                  }
               </Col>
            </Row>
            <div>
               <span className="h5 me-2 text-muted">Consigned Orders</span>
               <hr className="mt-0" />
            </div>
            <Row className="mb-3">
               <Col>
                  {data && data.consignedOrdersData && data.consignedOrdersData.length > 0
                     ? <ShippingScheduleConsignedGrid
                        cosigned={true}
                        data={data.consignedOrdersData}
                        exportXlsxCallback={exportConsignedOrdersXlsx}
                     />
                     : <span className="h5" style={{ color: "red" }}>No consigned orders found</span>
                  }
               </Col>
            </Row>
            <div>
               <span className="h5 me-2 text-muted">Sample Orders</span>
               <hr className="mt-0" />
            </div>
            <Row className="mb-3">
               <Col>
                  {data && data.sampleOrderData && data.sampleOrderData.length > 0
                     ? <ShipScheduleSampleOrderGrid
                        data={data.sampleOrderData}
                        sortCallback={onSampleOrderScheduleSortChange}
                        sortField={sampleOrderSortField}
                        sortDirection={sampleOrderSortDirection}
                        onUpdateRow={() => setLoaded(false)}
                        exportXlsxCallback={exportSampleOrderXlsx}
                     />
                     : <span className="h5" style={{ color: "red" }}>No sample orders found</span>
                  }
               </Col>
            </Row>
         </ServiceThreadSpinner>
      </React.Fragment>
   )
}